export default "__VITE_ASSET__eb07bc1f__"